import React, { useMemo } from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

import {AlignRightOutlined} from '@ant-design/icons';
import {Dropdown, Menu} from 'antd';

import {useWindowSize} from '../../hooks/useWindowSize';

import icon1 from '../../assets/icon/icon1.png';
import icon2 from '../../assets/icon/icon2.png';

import './index.css';

const menuItems = [
    {
        label: '首页',
        key: 'home',
    },
    {
        label: '资讯中心',
        key: 'ask',
    },
    {
        label: '帮助中心',
        key: 'help',
    },
    {
        label: '关于我们',
        key: 'us',
    },
];
export default function AppHeader({setContextValue}) {
    const navigate = useNavigate();
    const {isMobile} = useWindowSize();
    const location = useLocation();

    const onClick = e => {
        navigate(e.key);
    };

    const key = useMemo(() => location.pathname.split('/')[1], [location.pathname])

    return (
        <div className="header w-full h-[50px]">
            {isMobile ? (
                <div
                    id="header-mobile"
                    className="w-full h-full flex justify-end px-[24px]"
                >
                    <Dropdown
                        menu={{items: menuItems, onClick}}
                        trigger={['click']}
                    >
                        <AlignRightOutlined className="text-[24px]" />
                    </Dropdown>
                </div>
            ) : (
                <div
                    id="pc"
                    className="w-full h-full flex items-center justify-between px-[120px]"
                >
                    <div className="left-box flex-1 flex items-center gap-[40px]">
                        <div
                            className="flex items-center"
                        >
                            <img
                                className="w-[36px] h-[36px]"
                                src={icon1}
                                alt="晴风预报logo"
                                loading="lazy"
                            />
                            <span className="pc-text">晴风预报</span>
                        </div>

                        <div
                            className="flex items-center"
                        >
                            <img
                                className="w-[36px] h-[36px]"
                                src={icon2}
                                alt="光启学词logo"
                                loading="lazy"
                            />
                            <span className="pc-text">光启学词</span>
                        </div>
                    </div>

                    <div className="right-box flex-1 flex justify-end">
                        <Menu
                            defaultSelectedKeys={[key || 'home']}
                            className="border-none font-semibold"
                            onClick={onClick}
                            mode="horizontal"
                            items={menuItems}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
